import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const skipInk = { shouldForwardProp: (prop: PropertyKey) => prop !== "$ink" };

interface IInkProps {
  $ink?: boolean;
}

export const Legal = styled(
  Typography,
  skipInk
)<IInkProps>(({ theme, $ink }) => ({
  fontSize: 11,
  lineHeight: 1.5,
  color: $ink ? "rgba(255, 255, 255, 0.6)" : theme.palette.text.secondary,

  "& a": {
    color: "inherit",
    textDecoration: "underline",
  },
}));
